import { Directive, ElementRef, input, OnDestroy, inject } from '@angular/core';
import { DELETE, BACKSPACE, TAB, ESCAPE, ENTER, NUMPAD_PERIOD, PERIOD, COMMA } from '@angular/cdk/keycodes';
import { FormControl } from '@angular/forms';
import { isCELocale } from '@miq/utils';
@Directive({
  selector: '[miqOnlyNumbers]',
  host: {
    '(keydown)': 'onKeyDown($event)',
    '(paste)': 'blockPaste($event)',
  },
})
export class OnlyNumbersDirective implements OnDestroy {
  allowedKeyCodes = input<number[]>([]);
  restrictedKeyCodes = input<number[]>([]);
  formControl = input<FormControl>();
  inputElement: HTMLInputElement;
  public el = inject(ElementRef);
  private readonly ceLocale: boolean;
  constructor() {
    this.inputElement = this.el.nativeElement;
    this.ceLocale = isCELocale();
  }
  ngOnDestroy(): void {
    // Required by until destroy
  }
  private allowNegativeCharAtBeginning(e: Event) {
    const value = (e.currentTarget as HTMLInputElement)?.value?.toString() || '';
    const purgedValue = value.replace(/\-/g, '');
    if (!this.formControl()?.value) {
      this.formControl()?.setValue('-', { emitEvent: false });
      this.formControl()?.updateValueAndValidity();
      return;
    }
    e.preventDefault();
    this.formControl()?.setValue('-'.concat(purgedValue), { emitEvent: false });
    this.formControl()?.updateValueAndValidity();
  }
  // Allow typing numbers only
  onKeyDown(e: KeyboardEvent) {
    if (this.restrictedKeyCodes().includes(e.keyCode)) {
      e.preventDefault();
      return;
    }
    if (this.ceLocale && e.keyCode === COMMA && this.inputElement.value.includes(',')) {
      e.preventDefault();
      return;
    }
    if (
      //46, 8, 9, 27, 13, 110, 190
      [DELETE, BACKSPACE, TAB, ESCAPE, ENTER, PERIOD, NUMPAD_PERIOD, ...(this.ceLocale ? [COMMA] : [])].includes(
        e.keyCode
      ) ||
      // Allow: Ctrl+A
      (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
      // Allow: Ctrl+C
      (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
      // Allow: Ctrl+V
      (e.keyCode === 86 && (e.ctrlKey || e.metaKey)) ||
      // Allow: Ctrl+X
      (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||
      // Allow: home, end, left, right
      (e.keyCode >= 35 && e.keyCode <= 39)
    ) {
      // let it happen, don't do anything
      return;
    }
    // Ensure that it is a number and stop the keypress
    if ((e.shiftKey || e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105)) {
      if (!this.allowedKeyCodes().includes(e.keyCode)) {
        e.preventDefault();
      }
      // Validate number if a 'Minus' key was input
      if (e.keyCode === 189 || e.keyCode === 173 || e.keyCode === 109) {
        // Allow the key to go through, but make sure to check for number integrity
        this.allowNegativeCharAtBeginning(e);
      }
    }
  }
  // Prevent pasting into the input field
  blockPaste(e: KeyboardEvent) {
    e.preventDefault();
  }
}
